import { Model } from "@westpierstudio/luma/mvc";
import {  WedgesConfig } from "servertypes/gameevents/OpenGame";
import { CashWedgeID, FreeSpinWedgeID, JackpotWedgeID, MultiplierWedgeID, OrderedWedgeData, WedgeID } from "servertypes/SharedTypes";

export class WheelModel extends Model {
    orderedWedgeData: OrderedWedgeData = [];
    winningWedgeIndex = -1;

    processWedgeData(wedgesConfig: WedgesConfig, backendWedgeSequence: WedgeID[], currentCoinSize: number): void {

        const frontEndWedgeSequence = this.services.resources.getSetting(`wheel`).wedgeSequence;
        const wedgesSequence = this.validateWedgeSequence(frontEndWedgeSequence.slice(), backendWedgeSequence.slice());

        this.orderedWedgeData = [];

        for (const id of wedgesSequence) {

            if (id in CashWedgeID) {

                this.orderedWedgeData.push(
                    {
                        id,
                        coins: wedgesConfig.cashWedgesCoinsAwardsMap[id as CashWedgeID] * currentCoinSize
                    }
                );
            } else if (id in FreeSpinWedgeID) {

                this.orderedWedgeData.push(
                    {
                        id,
                        coins: wedgesConfig.freeSpinsWedgeCoinsAward * currentCoinSize,
                        freeSpins: wedgesConfig.freeSpinsWedgesAwardsMap[id as FreeSpinWedgeID]
                    }
                );
            } else if (id in JackpotWedgeID) {

                this.orderedWedgeData.push(
                    {
                        id,
                        coins: wedgesConfig.jackpotWedgesCoinsAwardsMap[id as JackpotWedgeID] * currentCoinSize
                    }
                );
            } else if (id in MultiplierWedgeID) {

                this.orderedWedgeData.push(
                    {
                        id,
                        coins: wedgesConfig.multiplierWedgesCoinsAward * currentCoinSize,
                        symbols: wedgesConfig.multipliersWedgesSymbolsMap[id as MultiplierWedgeID]
                    }
                );
            } else {
                throw new Error(`Unknown wedge id ${id}`);
            }
        }
    }

    validateWedgeSequence(frontEndWedgesSequence: WedgeID[], backEndWedgesSequence: WedgeID[]) {

        if (frontEndWedgesSequence.length !== backEndWedgesSequence.length) {
            throw new Error(
                `frontEndWedgesSequence length (${frontEndWedgesSequence.length}) does not match backEndWedgesSequence length "${backEndWedgesSequence.length}".\n
                frontEndWedgesSequence: [${frontEndWedgesSequence.toString()}]\n
                backEndWedgesSequence: [${frontEndWedgesSequence.toString()}]`
            );
        }

        for (const beId of backEndWedgesSequence) {
            const matches = frontEndWedgesSequence.filter(feId => feId === beId);
            if (matches.length > 1) {
                throw new Error(
                    `frontEndWedgesSequence contains duplicate ID's for "${beId}".\n
                    frontEndWedgesSequence: [${frontEndWedgesSequence.toString()}]\n
                    backEndWedgesSequence: [${frontEndWedgesSequence.toString()}]`
                );
            } else if (matches.length < 1) {
                throw new Error(
                    `frontEndWedgesSequence missing ID found in backend sequence "${beId}".\n
                    frontEndWedgesSequence: [${frontEndWedgesSequence.toString()}]\n
                    backEndWedgesSequence: [${frontEndWedgesSequence.toString()}]`
                );
            }
        }

        return frontEndWedgesSequence;
    }

    processWinningWedge(wedgeID: WedgeID): void {

        for (const [i, item] of this.orderedWedgeData.entries()) {

            if (item.id === wedgeID) {

                this.winningWedgeIndex = i;
                break;
            }
        }
    }

    override reset(): void {

        this.orderedWedgeData = [];
        this.winningWedgeIndex = -1;
    }
}